import React, { Component } from 'react'
import PropTypes from 'prop-types'
import WheelChartTooltip from './components/WheelChartTooltip'
import * as userWithSkills from '../../../../../assets/wheel_icons/withSkillsSmall.png'
import * as userWithoutSkills from '../../../../../assets/wheel_icons/withoutSkillsSmall.png'
import { capitalize } from '../../../../../utils/string'

export default class WheelZoomChart extends Component {
  static propTypes = {
    chartData: PropTypes.any,
  }

  constructor(props) {
    super(props)
    this.state = {
      /* For generating the WheelChart right-click context menu*/
      tooltip: {
        x: 0,
        y: 0,
        visibility: 'hidden',
        activeNode: { type: null },
      },
    }

    this.nodeStyle = node => {
      let image = null

      if (node.data.type === 'education') {
        image = `${process.env.REACT_APP_PUBLIC_BUCKET}diploma4BgWhite.png`
        node.label = capitalize(node.data.name)
        node.fillColor = '#ff9552'
        node.lineColor = '#ff9552'
        node.lineWidth = 2
        node.radius = 50
      }
      if (node.data.type === 'education' && !!node.data.is_target) {
        image = `${process.env.REACT_APP_PUBLIC_BUCKET}diplomaTargetBgWhite.png`
        node.label = capitalize(node.data.name)
        node.fillColor = '#ff9552'
        node.lineColor = '#ff9552'
        node.lineWidth = 2
        node.radius = 50
      }
      if (node.data.type === 'career' && !!node.data.is_target) {
        image = `${process.env.REACT_APP_PUBLIC_BUCKET}careerTarget.png`
        node.label = capitalize(node.data.name)
        node.fillColor = '#30bc9d'
        node.lineColor = '#30bc9d'
        node.lineWidth = 2
        node.radius = 50
      }
      if (node.data.type === 'career' && !node.data.is_target) {
        image = `${process.env.REACT_APP_PUBLIC_BUCKET}career1.png`
        node.label = capitalize(node.data.name)
        node.fillColor = '#30bc9d'
        node.lineColor = '#30bc9d'
        node.lineWidth = 2
        node.radius = 50
      }
      if (node.data.type === 'central') {
        image = null
        node.label = ''
        node.fillColor = '#5099E0'
        node.radius = 100
      }
      if (node.data.type === 'initial') {
        node.label = ''
        image = node.data.skills.length > 0 ? userWithSkills : userWithoutSkills
        node.fillColor = '#5099E0'
        node.lineColor = '#5099E0'
        node.lineWidth = 2
        node.radius = 100
      }
      if (node.data.name === 'Undefined') {
        node.label = 'Not Specified'
      }

      const sliceNo = node.data.foreign ? 1 : 0
      const sliceSize = 239
      node.image = image
      node.imageSlicing = [0, sliceNo * sliceSize, sliceSize, sliceSize]
    }

    this.linkStyle = link => {
      if (link.data.type === 'job_move') {
        link.fillColor = '#5099E0'
        link.radius = 4
        link.toDecoration = 'arrow'
      } else {
        link.fillColor = 'lightgray'
        link.radius = 2
        link.toDecoration = 'arrow'
      }
      if (link.data.type === 'higher_edu') {
        link.fillColor = '#5099E0'
        link.radius = 3
        link.toDecoration = 'arrow'
      }
    }

    // nodeFilter skipped
    // function updateFilters skipped in move

    // nodeFullChartClicked updates the resume list at the bottom of the page and was removed

    this.updateTooltip = event => {
      this.setState({
        tooltip: {
          x: event.x + 8,
          y: event.y + 40,
          activeNode: event.clickNode ? event.clickNode.data : null,
          visibility: 'visible',
        },
      })
    }

    this.hideTooltip = () => {
      this.setState({ tooltip: { ...this.state.tooltip, visibility: 'hidden' } })
    }

    this.constructChart = data => {
      return new window.NetChart({
        container: document.getElementById('wheelZoomChart'),
        area: {
          height: 600,
        },
        data: {
          preloaded: data,
        },
        interaction: {
          nodesMovable: false,
          zooming: {
            zoomExtent: [0.04, 1],
          },
        },
        navigation: {
          mode: 'showall',
          focusNodeExpansionRadius: 3,
          initialNodes: ['0'],
        },
        style: {
          node: {
            imageCropping: true,
          },
          nodeLabel: {
            padding: 5,
            textStyle: { font: '10px Open Sans' },
            backgroundStyle: { fillColor: 'transparent' },
          },
          nodeStyleFunction: this.nodeStyle,
          linkStyleFunction: this.linkStyle,
        },
        events: {
          onClick: this.updateTooltip.bind(this),
          onHoverChange: this.hideTooltip.bind(this),
        },
        nodeMenu: {
          enabled: false,
          showData: false,
        },
        layout: {
          mode: 'radial',
          nodeSpacing: 60,
        },
      })
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.constructChart(this.props.chartData)
    }, 100)
  }

  componentDidUpdate(nextProps) {
    if (nextProps.chartData !== this.props.chartData) {
      setTimeout(() => {
        this.constructChart(nextProps.chartData)
      }, 100)
    }
  }

  render() {
    return (
      <div style={{ minHeight: 643 }}>
        <WheelChartTooltip {...this.state.tooltip} />
        <div id="wheelZoomChart" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/WheelZoomChart.js